<template>
  <tooltip
    placement="top"
    :options="{ hideOnClick: true }"
    class-name="call-note-tooltip"
  >
    <template #trigger>
      <i class="fa-solid fa-comment text-primary"></i>
    </template>
    <template #tooltip>
      <div class="call-note-tooltip-content">
        <span class="whitespace-pre-line">{{ tooltipContent }}</span>
      </div>
    </template>
  </tooltip>
</template>

<script>
import Tooltip from "@/components/Tooltip.vue";

export default {
  components: {
    Tooltip,
  },
  props: {
    callNoteToolTip: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      tooltipContent: this.callNoteToolTip,
    };
  },
};
</script>

<style lang="scss">
.call-note-tooltip-theme {
  max-width: 350px !important;
}
.call-note-tooltip-content {
  word-wrap: break-word;
}
</style>
